module.exports = __webpack_public_path__ + "static/media/person-sitting-svgrepo-com.deda88bd.svg";